import { useEffect, useState } from "react";
import { startSyncEngine, subscribeSyncStatus, triggerSync, type SyncState } from "@/offline/syncEngine";

const INITIAL_STATE: SyncState = { status: "idle", pendingCount: 0, failedCount: 0 };

export function useOfflineSync() {
  const [state, setState] = useState<SyncState>(INITIAL_STATE);

  useEffect(() => {
    const unsubscribe = subscribeSyncStatus(setState);
    const stopEngine = startSyncEngine();
    return () => {
      unsubscribe();
      stopEngine();
    };
  }, []);

  return { ...state, retry: triggerSync };
}
